"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UrlAndQueryParams = /** @class */ (function () {
    function UrlAndQueryParams() {
    }
    UrlAndQueryParams.categoryId = 'categoryName';
    UrlAndQueryParams.rootCategoryId = 'mainCategoryName';
    UrlAndQueryParams.rootEntityId = 'cid';
    UrlAndQueryParams.typeId = 'tid';
    UrlAndQueryParams.subTypeId = 'stid';
    UrlAndQueryParams.isAutofill = 'isaf';
    UrlAndQueryParams.duplicateEntityId = 'deid';
    return UrlAndQueryParams;
}());
exports.UrlAndQueryParams = UrlAndQueryParams;
//# sourceMappingURL=url-and-query-params.js.map